var React = require('react');

function ToileDeJute (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.5 9h17l-2 11.2a1 1 0 0 1-1 .8H6.5a1 1 0 0 1-1-.8z","key":0}),React.createElement("path",{"d":"M8 9a4 4 0 0 1 8 0","key":1}),React.createElement("path",{"d":"M9 9.5v11M12 9.5v11M15 9.5v11","strokeWidth":"1","key":2}),React.createElement("path",{"d":"M4.2 13h15.6M4.9 17h14.2","strokeWidth":"1","key":3})]);
}

ToileDeJute.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = ToileDeJute;

ToileDeJute.default = ToileDeJute;
